<template>
    <!-- page-wrapper Start-->
    <div class="page-wrapper">
        <div class="container-fluid p-0">
            <!-- login page start-->
            <div class="authentication-main">
                <div class="row">
                    <div class="col-md-12">
                        <div class="auth-innerright">
                            <div class="authentication-box">
                                <div class="text-center">
                                    <img alt="" src="../../../assets/images/logo_gms.png" style="width: 405px">
                                </div>
                                <div class="card mt-4">
                                    <div class="card-body">
                                        <div class="text-center">
                                            <h4>SEGUIMIENTO</h4>
                                            <h6>Ingresa el código de compra.</h6>
                                        </div>
                                        <form class="theme-form">
                                            <div class="form-group">
                                                <label>Código de compra (requerido)</label>
                                                <b-form-input
                                                        type="text"
                                                        v-model="form.code.value">
                                                </b-form-input>
                                                <b-form-invalid-feedback :state="form.code.is_valid">{{form.code.message_error}}</b-form-invalid-feedback>
                                            </div>
                                            <div class="offset-5" v-show="isSend">
                                                <div class="loader">
                                                    <div class="line bg-primary"></div>
                                                    <div class="line bg-primary"></div>
                                                    <div class="line bg-primary"></div>
                                                    <div class="line bg-primary"></div>
                                                </div>
                                            </div>
                                            <div class="form-group form-row mt-3 mb-0">
                                                <button v-on:click="onSubmit" class="btn btn-primary btn-block" type="submit">Buscar</button>
                                            </div>
                                        </form>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <!-- login page end-->
        </div>
    </div>
    <!-- latest jquery-->
</template>

<script>
    import axios from "axios";
    import Multiselect from "vue-multiselect";
    import utils from '../../../utils';

    export default {
        name: 'login',
        data() {
            return {
                // PARA SABER SI ENVÍA EL CÓDIGO
                isSend: false,
                clientName: null,
                form: {
                    client: utils.defaultFields(),
                    type: utils.defaultFields({
                        value: 'BO'
                    }),
                    code: utils.defaultFields()
                }
            }
        },
        mounted() {
            this.clientName = this.$route.params.clientName;
            this.form.client.value = this.$route.params.clientName;
        },
        methods: {
            async onSubmit(evt){
                // console.log(evt)
                evt.preventDefault();
                // DATA DEL FORMULARIO
                let data = {};
                // VEMOS SI ES VÁLIDO
                let is_valid = utils.generateJsonStructure(this.form, data);
                if(is_valid){
                    this.isSend = true;
                    const path = `/api/route/v1.0/get_dispatch_trajectory/`;
                    const config = {
                        headers: {'Authorization': '' },
                        params: data
                    };
                    await axios.get(path, config).then((response) => {
                        // SI ES VÁLIDO LOS DATOS, NOS RETORNARÁ LA ID DEL DESPACHO
                        if(response['data']['dispatch_id'] !== undefined){
                            this.$router.push({'name': 'TrackingDisplay', params: { objectId: response['data']['dispatch_id'] }});
                        } else {
                            this.$swal({
                                title: '¡No encontrado!',
                                type: 'warning',
                                html: `La información proporcionada del despacho no se ha encontrado o aún no ha sido ingresada al sistema.`,
                            });
                        }
                    }).catch((error) => {
                        // ERROR 401 DA CUANDO NO SE ENVÍA EL TOKEN
                        console.log(error.response);
                        if(error.response.status === 400){
                            this.$swal({
                                title: 'Error',
                                type: 'error',
                                html: `Ha habido en error al conectarse con el servidor, intente nuevamente. Si el problema continúa, póngase en contacto con el administrador del sistema.`,
                            });
                        } else {
                            this.$swal({
                                title: '¡No encontrado!',
                                type: 'warning',
                                html: `La información proporcionada del despacho no se ha encontrado o aún no ha sido ingresada al sistema.`,
                            });
                        }
                    });
                    this.isSend = false;
                } else {
                    this.$swal({
                        title: 'Error',
                        type: 'error',
                        html: `Hay campos que no han sido completados correctamente, por favor, verifica nuevamente el formulario.`,
                    });
                }
            },
        }
    }
</script>